import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostMcpOAuthDenyRequest = {
	redirectUri: string;
	state: string;
};

export type PostMcpOAuthDenyResponse = {
	redirectTo: string;
};

export const postMcpOAuthDeny = createPostEndpoint<PostMcpOAuthDenyRequest, PostMcpOAuthDenyResponse>(
	'/api/mcp/oauth/authorize/deny'
);
